/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_AcceptInputs */

const en_cookie_consent_accept = /** @type {(inputs: Cookie_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const de_cookie_consent_accept = /** @type {(inputs: Cookie_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akzeptieren`)
};

const fr_cookie_consent_accept = /** @type {(inputs: Cookie_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter`)
};

const es_cookie_consent_accept = /** @type {(inputs: Cookie_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar`)
};

const it_cookie_consent_accept = /** @type {(inputs: Cookie_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta`)
};

const nl_cookie_consent_accept = /** @type {(inputs: Cookie_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepteren`)
};

const pl_cookie_consent_accept = /** @type {(inputs: Cookie_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaakceptuj`)
};

const fi_cookie_consent_accept = /** @type {(inputs: Cookie_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyvaksy`)
};

const da_cookie_consent_accept = /** @type {(inputs: Cookie_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter`)
};

const sv_cookie_consent_accept = /** @type {(inputs: Cookie_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptera`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Cookie_Consent_AcceptInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_accept = /** @type {((inputs?: Cookie_Consent_AcceptInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_AcceptInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_accept(inputs)
	if (locale === "fr") return fr_cookie_consent_accept(inputs)
	if (locale === "es") return es_cookie_consent_accept(inputs)
	if (locale === "it") return it_cookie_consent_accept(inputs)
	if (locale === "nl") return nl_cookie_consent_accept(inputs)
	if (locale === "pl") return pl_cookie_consent_accept(inputs)
	if (locale === "fi") return fi_cookie_consent_accept(inputs)
	if (locale === "da") return da_cookie_consent_accept(inputs)
	if (locale === "sv") return sv_cookie_consent_accept(inputs)
	return en_cookie_consent_accept(inputs)
});